import React, { useContext, useEffect, useRef, useState } from 'react';
import { Popover } from 'antd';
import { Routes, Route, Link } from 'react-router-dom';
import styled from 'styled-components';
import Logo from '../images/footerlogo.svg';
import { WalletContext } from '../context/WalletContext';
import { shortenAddress } from '../utils/shortenAddress';
import LockIcon from '../icons/Lock';
import breakpoints from '../utils/breakpoints';
import { GiHamburgerMenu } from 'react-icons/gi';
import { FaWallet } from 'react-icons/fa';
import { Button, Close } from '../UI';
import Modal from './Modal';
import { allNetworkIds, networks } from '../constants/networks';
import { AiOutlineDown } from 'react-icons/ai';
import eth from '../images/eth.svg';
import polygon from '../images/polygon.svg';
import bsc from '../images/bsc.svg';
import moonbeam from '../images/moonbeam.svg';
import copyIcon from '../images/copyIcon.svg';
import viewExplorer from '../images/viewExplorerIcon.svg';
import { getFromLocalStorage } from '../utils';
import './styles/Navbar.scss';

import gitbook from '../images/gitbook.svg';
import doc from '../images/document.svg';
import career from '../images/career.svg';
import faq from '../images/faq.svg';

const Bluebg = styled.div`
  display: none;

  @media ${breakpoints.device.sm} {
    display: none;
    width: 100%;
    height: 41px;
    background: #0045ff;
    box-shadow: 0px 2.00139px 4.00278px rgba(0, 0, 0, 0.05);
  }

  @media ${breakpoints.device.md} {
    display: none;
    width: 100%;
    height: 41px;
    background: #0045ff;
    box-shadow: 0px 2.00139px 4.00278px rgba(0, 0, 0, 0.05);
  }

  @media ${breakpoints.device.lg} {
    display: none;
  }
`;

const Nav = styled.div`
  padding: 3px 30px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70px;
  position: sticky;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 10;
  background: #ffffff;

  @media ${breakpoints.device.sm} {
    height: 65px;
    width: 100%;
    padding: 14.45px 20px;
  }

  @media ${breakpoints.device.md} {
    height: 65px;
    width: 100%;
    padding: 3px 30px;
    justify-content: space-between;
  }

  @media ${breakpoints.device.lg} {
    height: 70px;
    width: 100%;
    padding: 3px 30px;
  }

  .elm-left {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 30%;

    @media ${breakpoints.device.sm} {
      width: 15%;
    }

    @media ${breakpoints.device.md} {
      width: 20%;
    }

    .navbar-brand-img {
      width: 120.34px;
      height: 31.02px;
      @media ${breakpoints.device.sm} {
        display: none;
      }

      @media ${breakpoints.device.md} {
        display: none;
      }

      @media ${breakpoints.device.lg} {
        display: block;
      }
    }

    .mobile-logo {
      display: none;

      @media ${breakpoints.device.sm} {
        display: block;
        width: 30.67px;
        height: 30.91px;
        margin-right: 5px;
      }

      @media ${breakpoints.device.md} {
        display: block;
        width: 30.67px;
        height: 30.91px;
        margin-right: 5px;
      }

      @media ${breakpoints.device.lg} {
        display: none;
      }
    }
  }

  .elm-center {
    width: 50%;
    position: relative;

    @media only screen and ${breakpoints.device.sm} {
      display: none;
    }

    @media only screen and ${breakpoints.device.lg} {
      width: 50%;
      display: flex;
    }
  }

  .elm-center ul {
    font-weight: 600;
    font-size: 15.6086px;
    line-height: 24px;
    color: #6c6c6c;
  }

  .elm-right {
    width: 30%;
    display: flex;
    align-items: center;
    justify-content: end;

    @media ${breakpoints.device.sm} {
      display: flex;
      line-height: 0;
      width: 300px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    @media ${breakpoints.device.lg} {
      width: 30%;
      display: flex;
      align-items: center;
      justify-content: end;
    }
  }

  .connectNetwork {
    border: none;
    background: #dbeaff;
    border-radius: 6px;
    color: #808080;
    cursor: pointer;
    width: 100%;
    height: 38px;

    @media only screen and ${breakpoints.device.sm} {
      width: 110px;
      height: 22.44px;
      font-size: 9px;
      padding: 0;
      border-radius: 3.20596px;
      font-weight: 700;
    }

    @media only screen and ${breakpoints.device.md} {
      width: 110px;
      height: 22.44px;
      font-size: 9px;
      padding: 0;
      border-radius: 3.20596px;
      font-weight: 700;
    }

    @media only screen and ${breakpoints.device.lg} {
      background: #dbeaff;
      border: none;
      border-radius: 6px;
      display: flex;
      width: 100%;
      height: 38px;
      align-items: center;
      justify-content: center;
      padding: 10px;
      font-style: normal;
      font-weight: 700;
      font-size: 13px;
      line-height: 15px;
      color: #808080;
      cursor: pointer;
      font-family: 'Public Sans';
      font-style: normal;
      font-weight: 700;
    }
  }

  .openMenu {
    position: relative;
    background: none;
    border: none;
    color: #0045ff;
    cursor: pointer;
    display: none;
    @media only screen and ${breakpoints.device.sm} {
      color: #0045ff;
      position: relative;
      display: block;
    }

    @media only screen and ${breakpoints.device.md} {
      color: #0045ff;
    }

    @media only screen and ${breakpoints.device.lg} {
      display: none;
    }
  }

  .userBx {
    @media only screen and ${breakpoints.device.max_sm} {
      font-size: 1.8rem !important;
    }
  }

  .ethbal {
    width: 230px;
    height: 34px;
    padding: 10px 10px;
    margin-right: 0px;
    border-radius: 6px;
    background-color: #dbeaff;
    color: #000;
    font-weight: 700;
    font-size: 13px;
    line-height: 15px;
    display: flex;
    align-items: center;
    color: #808080;
    position: relative;

    @media only screen and ${breakpoints.device.sm} {
      padding: 5px 6px;
      width: 135px;
      height: 22.44px;
      font-size: 9px;
      border-radius: 3.20596px;
      position: relative;
    }

    @media only screen and ${breakpoints.device.md} {
      padding: 5px 6px;
      width: 135px;
      height: 22.44px;
      font-size: 9px;
      border-radius: 3.20596px;
      position: relative;
    }

    @media only screen and ${breakpoints.device.lg} {
      padding: 10px;
      margin-right: 0px;
      width: 225px;
      font-size: 13px;
      height: 38px;
    }
  }

  .address {
    position: absolute;
    top: 17.33px;
    right: 45px;
    width: 124px;
    height: 28px;
    background: #ffffff;
    border-radius: 5.36px;
    font-weight: 700;
    font-size: 11.6133px;
    line-height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #808080;
    cursor: pointer;

    @media only screen and ${breakpoints.device.sm} {
      padding: 5px 6px;
      width: 67.1px;
      height: 17.86px;
      font-size: 9px;
      border-radius: 2.90036px;
      right: 5%;
      top: 9%;
      position: absolute;
    }

    @media only screen and ${breakpoints.device.md} {
      padding: 5px 6px;
      width: 67.1px;
      height: 17.86px;
      font-size: 9px;
      border-radius: 2.90036px;
      right: 5%;
      top: 9%;
      position: absolute;
    }

    @media only screen and ${breakpoints.device.lg} {
      padding: 0;
      position: absolute;
      top: 15%;
      right: 5%;
      width: 124px;
      height: 28px;
      background: #ffffff;
      border-radius: 5.36px;
      font-weight: 700;
      font-size: 11.6133px;
      line-height: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #808080;
      cursor: pointer;
    }
  }

  .top-btn p {
    margin-left: 10px;
    font-weight: 700;
    font-size: 13px;
    line-height: 15px;
    letter-spacing: -0.035em;
  }

  a {
    text-decoration: none;
  }

  .navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 70%;
    ul {
      margin: 0;
      display: flex;
      width: 80%;
      justify-content: space-between;
    }
    li {
      font-weight: 500;
      display: flex;
      align-items: center;
      color: grey;
      svg {
        margin-left: 5px;
      }

      &.open a {
        text-decoration: none;
        color: #0045ff;
        -webkit-transition: all 0.2s ease-in-out;
        transition: all 0.2s ease-in-out;
        box-sizing: border-box;
        padding: 5px 12px;
        &:hover {
          color: #0045ff;
          cursor: pointer;
          padding: 5px 12px;
          outline: 0px solid transparent;
          border: 0px solid;
          -webkit-transition: all 0.2s ease-in-out;
          transition: all 0.2s ease-in-out;
          box-sizing: border-box;
          background: #dbeaff;
          border-radius: 5px;
        }
      }
    }
  }
`;

const ExtendedNav = styled.div`
  position: relative;

  .extendNav {
    width: 80vw;
    height: 400px;
    transition: 0.6s;
    text-align: center;

    .open {
      a {
        @media only screen and ${breakpoints.device.sm} {
          color: grey;
          text-decoration: none;
        }

        @media only screen and ${breakpoints.device.lg} {
          display: none;
        }
      }
    }
  }

  .close {
    position: absolute;
    left: 10%;
    top: 5%;
    z-index: 10;
    display: none;
  }

  .navigation {
    width: 150px;
    height: 130px;
    background: #ffffff;
    border-radius: 7.17521px;
    padding: 15px 10px;
    position: absolute;
    right: 6%;
    z-index: 2;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  }

  .navigation li {
    padding-bottom: 15px;
    font-size: 8.28819px;
    font-weight: 700;
    color: #2b6def;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  }
`;

//set selected chain logo to a state
//display selected chain

const Navbar = () => {
  const {
    currentAccount,
    currentNetworkId,
    isConnected,
    accountBalance,
    connectWallet,
    disconnect,
    switchNetwork,
  } = useContext(WalletContext);

  const [extendNavBar, setExtendNavbar] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [currentNetwork, setCurrentNetwork] = useState('');
  const [chainModal, setChainModal] = useState(false);

  const ref = useRef();

  useEffect(() => {
    const closeDropDown = (event) => {
      if (!ref.current.contains(event.target)) {
        setExtendNavbar(false);
      }
    };
    document.addEventListener('mousedown', closeDropDown);

    return () => document.body.removeEventListener('mousedown', closeDropDown);
  }, []);

  useEffect(() => {
    const fromLocal = getFromLocalStorage('currentAccount');
    const network = networks[currentNetworkId]
      ? networks[currentNetworkId]?.chainName
      : fromLocal?.network;
    setCurrentNetwork(network);
  }, [currentNetworkId]);

  useEffect(() => {
    if (isConnected && currentNetworkId !== allNetworkIds.sepolia) {
      setModalVisible(true);
    } else {
      setModalVisible(false);
    }
  }, [currentNetworkId]);

  const walletModalBody = () => {
    return (
      <div className='walletModel'>
        <h1>Wrong Network</h1>
        <p>
          UniLend V2 is in testnet phase. <br /> Please connect to the SEPOLIA
          network.
        </p>
        <div>
          <button onClick={() => switchNetwork('11155111')}>
            Switch Network
          </button>
        </div>
      </div>
    );
  };

  const templateNetwork = () => {
    return (
      <div>
        <div className='m-r-1' onClick={() => setChainModal(!chainModal)}>
          {currentNetwork && (
            <Button className='connectNetwork'>
              {currentNetwork ? currentNetwork : 'Select a Network'}
            </Button>
          )}
        </div>

        {false && (
          <div className='chain-modal'>
            <h3>Select a network</h3>

            <div
              className={`chain-modalbtn ${
                currentNetworkId === allNetworkIds.mainNet ? 'chainActive' : ''
              }`}
              onClick={() => switchNetwork('1')}
            >
              <img src={eth} alt='' />

              <p>Ethereum</p>

              <div
                className={
                  currentNetworkId === allNetworkIds.mainNet ? 'chainbtn' : ''
                }
              ></div>
            </div>

            <div
              className={`chain-modalbtn ${
                currentNetworkId === allNetworkIds.polygonMainNet
                  ? 'chainActive'
                  : '' === 'polygon'
                  ? 'chainActive'
                  : ''
              }`}
              onClick={() => switchNetwork('137')}
            >
              <img src={polygon} alt='' />

              <p>Polygon</p>

              <div
                className={
                  currentNetworkId === allNetworkIds.polygonMainNet
                    ? 'chainbtn'
                    : ''
                }
              ></div>
            </div>

            <div
              className={`chain-modalbtn ${
                currentNetworkId === allNetworkIds.binanceMainNet
                  ? 'chainActive'
                  : ''
              }`}
              onClick={() => switchNetwork('56')}
            >
              <img src={bsc} alt='' />

              <p>BSC</p>
              <div
                className={
                  currentNetworkId === allNetworkIds.binanceMainNet
                    ? 'chainbtn'
                    : ''
                }
              ></div>
            </div>

            <div
              className={`chain-modalbtn ${
                currentNetworkId === allNetworkIds.moonMainNet
                  ? 'chainActive'
                  : ''
              }`}
              onClick={() => switchNetwork('1284')}
            >
              <img src={moonbeam} alt='' />

              <p>MoonBeam</p>
              <div
                className={
                  currentNetworkId === allNetworkIds.moonMainNet
                    ? 'chainbtn'
                    : ''
                }
              ></div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const TemplateConnection = () => {
    const [visible, setVisible] = useState(false);

    const handleVisibleChange = (newVisible) => {
      setVisible(newVisible);
    };

    const PopoverContent = () => {
      const [copied, setCopied] = useState(false);

      const copyToClipboard = () => {
        navigator.clipboard.writeText(currentAccount);
        setCopied(true);
      };

      return (
        <div className='popover-content'>
          <div className='disconnect'>
            <div>
              <p></p>
            </div>
            <h4>{shortenAddress(currentAccount)}</h4>
            <Button className='style-active' onClick={disconnect}>
              Disconnect
            </Button>
          </div>
          <div className='explorer'>
            <div onClick={copyToClipboard} className={copied && 'copied'}>
              <img src={copyIcon} alt='copyicon' />
              <p> {copied ? 'Copied' : 'Copy address'}</p>
            </div>
            <Link to='/history'>
              <div>
                <img src={viewExplorer} alt='viewExplorericon' />
                <p>TXN History</p>
              </div>
            </Link>
          </div>
        </div>
      );
    };

    return (
      <>
        <div className=''>
          {!currentAccount ? (
            <Button onClick={connectWallet} className='style-dark'>
              Connect Wallet
            </Button>
          ) : (
            <div className='userBx'>
              {!currentAccount ? (
                ''
              ) : (
                <div className='ethbal'>
                  <span>{accountBalance} ETH</span>
                  <Popover
                    content={<PopoverContent />}
                    trigger='click'
                    overlayClassName='antd-popover-classname'
                    placement='bottomLeft'
                    visible={visible}
                    onVisibleChange={handleVisibleChange}
                  >
                    <span className='address'>
                      {shortenAddress(currentAccount)}
                    </span>
                  </Popover>
                </div>
              )}
            </div>
          )}
        </div>
      </>
    );
  };

  return (
    <>
      <Bluebg className='blueBg'></Bluebg>
      <Nav>
        <li className='elm-left'>
          <Link to='/'>
            <img src={Logo} className='navbar-brand-img' alt='...' />
            <img
              src={require('../images/mobileLogo.svg').default}
              className='mobile-logo'
              alt='...'
            />
          </Link>
        </li>

        <li className='elm-center'>
          <div className='navigation'>
            <ul>
              <li className='open'>
                <Link to='/'>Pools</Link>
              </li>
              {/* <li className="open">
                <Link to="/">User Dashboard</Link>
              </li> */}
              <li>
                Vote
                <LockIcon width={20} height={20}></LockIcon>
              </li>
              <li>
                Rewards
                <LockIcon width={20} height={20}></LockIcon>
              </li>
              <li className='open'>
                <Link to='/history'>History</Link>
              </li>
              <li className='open'>
                <a
                  href='https://chaindrop.org/?chainid=11155111&token=0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee'
                  target='_blank'
                >
                  Faucet
                </a>
              </li>
            </ul>
          </div>
        </li>

        <li className='elm-right'>
          {templateNetwork()}
          {<TemplateConnection />}
        </li>

        <div
          className='openMenu'
          onClick={() => {
            setExtendNavbar((prev) => !prev);
          }}
        >
          <img src={require('../images/hamburger.svg').default} />
        </div>
      </Nav>
      {extendNavBar && (
        <ExtendedNav className='overlay'>
          {/* {extendNavBar ? (
            <div className="close">
              <Close onClick={() => setExtendNavbar(false)}>&#10005;</Close>
            </div>
          ) : (
            <GiHamburgerMenu />
          )} */}
          <div className='navigation' ref={ref}>
            <a
              href='https://unilend.gitbook.io/unilend-finance/'
              target='_blank'
            >
              <li>
                <span>Gitbook</span>
                <img src={gitbook} />
              </li>
            </a>

            <a
              href='https://unilend.gitbook.io/unilend-finance/whitepaper'
              target='_blank'
            >
              <li>
                <span>Documentation</span>
                <img src={doc} />
              </li>
            </a>
            <a
              href='https://twitter.com/UniLend_Finance'
              target='_blank'
            >
              <li>
                <span>Career</span>
                <img src={career} />
              </li>
            </a>
            {/* <a
              href='https://unilend.gitbook.io/unilend-finance/'
              target='_blank'
            ></a> */}
            <li>
              <span>FAQ</span>
              <img src={faq} />
            </li>
          </div>
        </ExtendedNav>
      )}
      {modalVisible ? (
        <Modal
          modalVisible={modalVisible}
          htmlBody={walletModalBody}
          callToAction='Switch to Sepolia'
          height='300px'
          padding='0px'
        />
      ) : (
        ''
      )}
    </>
  );
};

export default Navbar;
